import PropTypes from "prop-types";
import { useEffect, useState } from "react";

function MDConfirmAlert({ text, confirmFunction, cancelFunction, toast, t }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    document.body.classList.add('confirm-alert');
    // Trigger animation after mount
    setTimeout(() => setIsVisible(true), 10);
    
    return () => {
      document.body.classList.remove('confirm-alert');
    };
  }, []);

  const handleConfirm = () => {
    setIsVisible(false);
    setTimeout(() => confirmFunction(), 150);
  };

  const handleCancel = () => {
    setIsVisible(false);
    setTimeout(() => {
      if (!cancelFunction) {
        toast?.dismiss(t?.id);
      } else {
        cancelFunction();
      }
    }, 150);
  };

  return (
    <>
      <div style={{...styles.container, opacity: isVisible ? 1 : 0}}>
        <div style={styles.backdrop} onClick={handleCancel}></div>
        <div style={{
          ...styles.modal,
          transform: isVisible ? 'translate(-50%, -50%) scale(1)' : 'translate(-50%, -50%) scale(0.9)',
          opacity: isVisible ? 1 : 0
        }}>
          <div style={styles.header}>
            <div style={styles.iconContainer}>
              <svg style={styles.icon} viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
            </div>
            <h3 style={styles.title}>Confirm Action</h3>
          </div>
          <div style={styles.content}>
            <p style={styles.message}>{text}</p>
          </div>
          <div style={styles.buttonContainer}>
            <button 
              style={styles.button.cancel} 
              onClick={handleCancel}
              onMouseEnter={(e) => e.target.style.backgroundColor = styles.button.cancel.hover.backgroundColor}
              onMouseLeave={(e) => e.target.style.backgroundColor = styles.button.cancel.backgroundColor}
            >
              Cancel
            </button>
            <button 
              style={styles.button.confirm} 
              onClick={handleConfirm}
              onMouseEnter={(e) => e.target.style.backgroundColor = styles.button.confirm.hover.backgroundColor}
              onMouseLeave={(e) => e.target.style.backgroundColor = styles.button.confirm.backgroundColor}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

MDConfirmAlert.defaultProps = {
  text: '',
  confirmFunction: false,
  cancelFunction: false,
  toast: false,
  t: false
}

MDConfirmAlert.propTypes = {
  text: PropTypes.string,
  confirmFunction: PropTypes.func,
  cancelFunction: PropTypes.func,
  toast: PropTypes.any,
  t: PropTypes.any
}

export default MDConfirmAlert;

const styles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'opacity 0.15s ease-out',
  },
  backdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    backdropFilter: 'blur(4px)',
    cursor: 'pointer',
  },
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) scale(0.9)',
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15), 0 4px 6px rgba(0, 0, 0, 0.1)',
    width: '90%',
    maxWidth: '480px',
    minWidth: '320px',
    overflow: 'hidden',
    transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
    border: '1px solid rgba(0, 0, 0, 0.08)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '24px 24px 16px 24px',
    borderBottom: '1px solid #f0f0f0',
  },
  iconContainer: {
    width: '48px',
    height: '48px',
    borderRadius: '12px',
    backgroundColor: '#fff3e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '16px',
    flexShrink: 0,
  },
  icon: {
    width: '24px',
    height: '24px',
    color: '#ff9800',
  },
  title: {
    margin: 0,
    fontSize: '20px',
    fontWeight: '600',
    color: '#1a1a1a',
    lineHeight: '24px',
  },
  content: {
    padding: '20px 24px',
  },
  message: {
    margin: 0,
    fontSize: '16px',
    fontWeight: '400',
    color: '#4a4a4a',
    lineHeight: '24px',
    wordBreak: 'break-word',
  },
  buttonContainer: {
    display: 'flex',
    gap: '12px',
    padding: '16px 24px 24px 24px',
    justifyContent: 'flex-end',
  },
  button: {
    cancel: {
      backgroundColor: '#f5f5f5',
      color: '#666666',
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      padding: '12px 24px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      minWidth: '80px',
      outline: 'none',
      hover: {
        backgroundColor: '#e8e8e8',
      }
    },
    confirm: {
      backgroundColor: '#1976d2',
      color: '#ffffff',
      border: '1px solid #1976d2',
      borderRadius: '8px',
      padding: '12px 24px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      minWidth: '80px',
      outline: 'none',
      hover: {
        backgroundColor: '#1565c0',
      }
    },
  },
};
